/* eslint-disable no-plusplus */
import React from 'react';

import Zoom from './Zoom';
import Playback from './Playback';
import Mute from './Mute';

import classes from './styles.module.scss';

function getCurrentTimeString(currentTime) {
  const hours = Math.floor(currentTime / 3600)
    .toString()
    .padStart(2, '0');
  const minutes = Math.floor((currentTime % 3600) / 60)
    .toString()
    .padStart(2, '0');
  const seconds = Math.floor(currentTime % 60)
    .toString()
    .padStart(2, '0');

  return `${hours}:${minutes}:${seconds}`;
}

export default function Controls({
  zoom,
  setZoom,
  frameWidth,
  section,
  videoRef,
  isVideoPlaying,
  startTime,
  endTime,
  frameCount,
  onTimeUpdate,
  currentTime = 0,
}) {
  const duration = section?.duration || 0;

  return (
    <div className={classes.Controls}>
      <Zoom
        zoom={zoom}
        setZoom={setZoom}
        frameWidth={frameWidth}
        section={section}
        frameCount={frameCount}
        duration={duration}
      />
      <Playback
        videoRef={videoRef}
        isVideoPlaying={isVideoPlaying}
        startTime={startTime}
        endTime={endTime}
        onTimeUpdate={onTimeUpdate}
      />
      <div className={classes.rightControls}>
        <div className={classes.timestamp}>
          <span>
            {getCurrentTimeString(currentTime)} / {getCurrentTimeString(duration)}
          </span>
        </div>
      <Mute videoRef={videoRef} />
      </div>
    </div>
  );
}
